/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { SelectInput, UnifiedInput } from '../Input';
import { Checkbox, Grid, SelectChangeEvent } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../utils/redux';
import {
  // buildingFloorsSelector,
  buildingIdSelector,
  buildingsListSelector,
} from '../../redux/selectors/building';
import { CONTROLLER, GATEWAY, SENSOR } from '../../const/values';
import { controllersSelectListSelector } from '../../redux/selectors/device';
import { companyIdSelector } from '../../redux/selectors/company';
import { DeviceUpdateProps } from '../../const/types';
import ColorType from '../Theme/ColorType';
import SelectSearch from '../Input/SelectSearch';
import { useTranslation } from 'react-i18next';
import { ActionButton } from '../Button';
import ChannelModal from '../Modal/ChannelModal';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutline';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import { PencilSquare } from '../svg';
import {
  isAdminSelector,
  isBuildingManagerSelector,
  isManagerSelector,
} from '../../redux/selectors/user';
import PopupConfirmDelete from '../Modal/PopupConfirmDelete';
import {
  PermaDeleteDeviceAccount,
  SilenceDevice,
} from '../../redux/actions/deviceAction';
import { useNavigate } from 'react-router';
import PopupConfirmSilence from '../Modal/PopupConfirmSilence';
import axios from 'axios';

type ErrorProp = {
  deviceEUI?: string;
  applicationKey?: string;
  deviceApplicationEUI?: string;
  devicePin?: string;
  model?: string;
  serialNumber?: string;
  assetNumber?: string;
  ipAddress?: string;
  mac?: string;
  latitude?: string;
  longitude?: string;
  altitude?: string;
  status?: string;
  floor?: string;
  floorArea?: string;
  floorSubArea?: string;
  awsId?: string;
};

const DeviceUpdateCard = ({
  gateway,
  controller,
  sensor,
  handleSendData,
}: DeviceUpdateProps) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const activeLocale = i18n.resolvedLanguage;
  const buildings = useAppSelector(buildingsListSelector);
  const buildingId = useAppSelector(buildingIdSelector);
  const companyId = useAppSelector(companyIdSelector);
  const controllersIds = useAppSelector(controllersSelectListSelector);
  const isAdmin = useAppSelector(isAdminSelector);
  const isManager = useAppSelector(isManagerSelector);
  const isBuildingManager = useAppSelector(isBuildingManagerSelector);
  const [gatewayName, setGatewayName] = useState('');
  const [deviceEUI, setDeviceEUI] = useState('');
  const [deviceApplicationEUI, setDeviceApplicationEUI] = useState('');
  const [applicationKey, setApplicationKey] = useState('');
  const [model, setModel] = useState('');
  const [serialNumber, setSerialNumber] = useState('');
  const [assetNumber, setAssetNumber] = useState('');
  const [errors, setErrors] = useState<ErrorProp>({});
  const [floor, setFloor] = useState('0');
  const [floorArea, setFloorArea] = useState('');
  const [floorSubArea, setFloorSubArea] = useState('');
  const [awsId, setAwsId] = useState('');
  const [building, setBuilding] = useState('');
  const [devices, setDevices] = useState<any>([]);
  const [channelA, setChannelA] = useState(false);
  const [channelB, setChannelB] = useState(false);
  const [channels, setChannels] = useState<any[]>();
  const [isSelectChannel, setIsSelectChannel] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [confirmSilence, setConfirmSilence] = useState(false);
  const [options, setOptions] = useState<any>([]);
  const [meta, setMeta] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [controllerDropdownOpen, setControllerDropdownOpen] = useState(false);
  // const floorCount = useAppSelector((state) =>
  //   buildingFloorsSelector(state, parseInt(building, 10))
  // );

  const handleOpenDeleteModal = () => setConfirmDelete(true);
  const handleCloseDeleteModal = () => setConfirmDelete(false);

  const handleOpenSilenceModal = () => setConfirmSilence(true);
  const handleCloseSilenceModal = () => setConfirmSilence(false);
  const componentType = !!gateway
    ? GATEWAY
    : !!controller
    ? CONTROLLER
    : SENSOR;

  useLayoutEffect(() => {
    if (gateway) {
      setGatewayName(gateway?.name);
    }
    setFloor((gateway || controller || sensor)?.device_location.floor || '');
    setFloorArea(
      (gateway || controller || sensor)?.device_location?.floor_area || ''
    );
    setFloorSubArea(
      (gateway || controller || sensor)?.device_location?.floor_sub_area || ''
    );
    setAwsId((controller || sensor)?.aws_id || '');
    setDeviceEUI((controller || sensor)?.eui || '');
    setDeviceApplicationEUI((controller || sensor)?.dev_application_eui || '');
    setApplicationKey((controller || sensor)?.application_key || '');
    setModel((controller || sensor)?.model || '');
    setSerialNumber((controller || sensor)?.serial_number || '');
    setAssetNumber((controller || sensor)?.asset_number || '');
    if (sensor) {
      /* @ts-ignore */
      const DeviceList = sensor.controllers.map(
        (device: any) => device.asset_number
      );
      const newDevices = controllersIds.filter((controller) =>
        DeviceList.includes(controller.label)
      );
      setDevices(newDevices);
      /* @ts-ignore */
      sensor?.assigned_controllers?.map((control) => {
        if (control.channels === 'A' || control.channels === 'AB') {
          setChannelA(true);
        }
        if (control.channels === 'B' || control.channels === 'AB') {
          setChannelB(true);
        }
      });
    }

    if (controller) {
      controller.channels?.map((channel) => {
        if (channel.channel_code === 'A') {
          setChannelA(true);
        } else if (channel.channel_code === 'B') {
          setChannelB(true);
        }
      });
    }

    return () => {
      setErrors({});
      setGatewayName('');
      setFloor('0');
      setFloorArea('');
      setFloorSubArea('');
      setAwsId('');
      setDeviceEUI('');
      setDeviceApplicationEUI('');
      setApplicationKey('');
      setModel('');
      setSerialNumber('');
      setAssetNumber('');
    };
  }, [controller, controllersIds, gateway, sensor]);

  useEffect(() => {
    if (sensor && devices.length > 0 && devices.length < 2) {
      /* @ts-ignore */
      devices?.map((device) => {
        /* @ts-ignore */
        sensor?.assigned_controllers.map((ac) => {
          if (device.value === ac.controller_id) {
            if (ac.channels === 'A' || ac.channels === 'AB') {
              setChannelA(true);
            } else {
              setChannelA(false);
            }
            if (ac.channels === 'B' || ac.channels === 'AB') {
              setChannelB(true);
            } else {
              setChannelB(false);
            }
          } else {
            setChannelA(false);
            setChannelB(false);
          }
        });
      });
    }
  }, [devices, sensor]);

  useEffect(() => {
    if (gateway) setBuilding(gateway.building.id.toString());
    if (sensor) setBuilding(sensor.building.id.toString());
    if (controller) setBuilding(controller.building.id.toString());
  }, [buildingId, buildings, controller, gateway, sensor]);

  // const Floors = [
  //   { value: '0', label: 'Choose a number of floors', placeholder: true },
  //   ...Array.from({ length: floorCount || 0 }, (_, index) => ({
  //     value: (index + 1).toString(),
  //     label: (index + 1).toString(),
  //   })),
  // ];

  const stateSetters: any = {
    name: setGatewayName,
    deviceEUI: setDeviceEUI,
    deviceApplicationEUI: setDeviceApplicationEUI,
    applicationKey: setApplicationKey,
    model: setModel,
    serialNumber: setSerialNumber,
    assetNumber: setAssetNumber,
    floorArea: setFloorArea,
    floorSubArea: setFloorSubArea,
    awsId: setAwsId,
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    const setter = stateSetters[name];
    if (setter) {
      setter(value);
    }
  };

  const handleChangeBuilding = (event: SelectChangeEvent) => {
    setBuilding(event.target.value);
  };

  const handleChangeFloor = (event: SelectChangeEvent) => {
    setFloor(event.target.value);
  };

  const sendData = () => {
    if (gateway) {
      const data = {
        name: gatewayName,
        building_id: building,
        company_id: companyId,
        floor,
        floor_area: floorArea,
        floor_sub_area: floorSubArea,
        status: true,
      };
      return handleSendData(data, componentType);
    }

    let channel = '';

    if (channelA && channelB) {
      channel = 'AB';
    } else if (channelB) {
      channel = 'B';
    } else {
      channel = 'A';
    }

    let deviceIds: any[] | undefined = [];
    if (devices.length > 0 && channels && channels.length > 0) {
      deviceIds = channels?.map((channel: any) => `${channel.device}`) || [];
    } else if (devices.length > 0) {
      deviceIds = devices.map((device: any) => `${device.value}_${channel}`);
    }
    const data = {
      asset_number: assetNumber,
      serial_number: serialNumber,
      eui: deviceEUI,
      application_key: applicationKey,
      dev_application_eui: deviceApplicationEUI,
      model,
      building_id: parseInt(building, 10),
      company_id: companyId,
      floor,
      floor_area: floorArea,
      floor_sub_area: floorSubArea,
      aws_id: awsId,
      device_ids: deviceIds,
      channels: channel,
    };
    handleSendData(data, componentType);
  };

  const handleOpen = () => setIsSelectChannel(true);
  const handleClose = () => setIsSelectChannel(false);

  const handleDeleteDevice = () => {
    dispatch(
      PermaDeleteDeviceAccount({
        deviceId: (controller || sensor)?.id,
        companyId,
        buildingId,
        componentType,
        handleClose: handleCloseDeleteModal,
        navigate,
      })
    );
  };

  const handleSilenceDevice = () => {
    dispatch(
      SilenceDevice({
        deviceId: (controller || sensor)?.id,
        companyId,
        buildingId,
        handleClose: handleCloseSilenceModal,
        navigate,
        silenced: sensor?.silenced,
      })
    );
  };

  const fetchItems = async (page = 1) => {
    if (loading) return;

    setLoading(true);

    try {
      const url = `/devices?type=controller&page=${page}&company_id=${companyId}&keyword=&sort=building_name`;
      const result = await axios.get(url);

      setOptions((prev: any) => {
        const idList = [
          ...result?.data.data?.items?.map((item: any) => ({
            value: item.id,
            label: item.asset_number,
            etage: item?.device_location?.floor,
            area: item?.device_location?.floor_area,
            subArea: item?.device_location?.floor_sub_area,
            devEui: item?.dev_application_eui,
          })),
        ];
        // Page 1 replaces existing data.
        if (page === 1) {
          return idList;
        }

        // Other pages are appended.
        return [...prev, ...idList];
      });

      setMeta(result?.data?.data?.meta);
    } catch (error) {
      console.error('Failed to fetch items:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = (event: any) => {
    const listbox = event.currentTarget;

    const isNearBottom =
      listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 50;

    if (!isNearBottom || loading || !meta) {
      return;
    }

    const hasNextPage = meta.current_page < meta.last_page;

    if (hasNextPage) {
      fetchItems(meta.current_page + 1);
    }
  };

  useEffect(() => {
    fetchItems(1);
  }, []);

  useEffect(() => {
    if (!controllerDropdownOpen || loading || !meta) return;

    const hasNextPage = meta.current_page < meta.last_page;
    if (!hasNextPage) return;

    const unselectedCount = options.filter(
      (option: any) =>
        !devices.some((device: any) => device?.value === option.value)
    ).length;

    if (unselectedCount < 8) {
      fetchItems(meta.current_page + 1);
    }
  }, [controllerDropdownOpen, loading, meta, options, devices]);

  const mergedOptions = [
    ...devices,
    ...options.filter(
      (option: any) =>
        !devices.some(
          (device: any) => String(device.value) === String(option.value)
        )
    ),
  ];

  return (
    <Container>
      <TitleContainer>{t('device-update-title')}</TitleContainer>
      {gateway && (
        <RowContainer container>
          <FieldContainer item xs={12} sm={12} md lg>
            <FieldDescription>{t('device-add-gateway-label')}</FieldDescription>
            <UnifiedInput
              placeholder={t('device-add-gateway-label')}
              hasBorder
              value={gatewayName}
              name="name"
              OnChange={handleChange}
              error={!!errors?.deviceEUI}
              errorMessage={errors?.deviceEUI}
            />
          </FieldContainer>
          <FieldContainer item xs={12} sm={12} md lg>
            <FieldDescription>
              {t('device-add-building-label')}
            </FieldDescription>
            <SelectInput
              values={buildings}
              value={building}
              OnChange={handleChangeBuilding}
            />
          </FieldContainer>
        </RowContainer>
      )}
      {!gateway && (
        <RowContainer container>
          <FieldContainer item xs={12} sm={12} md lg>
            <FieldDescription>{t('device-add-eui-label')}</FieldDescription>
            <UnifiedInput
              placeholder={t('device-add-eui-label')}
              hasBorder
              value={deviceEUI}
              name="deviceEUI"
              OnChange={handleChange}
              error={!!errors?.deviceEUI}
              errorMessage={errors?.deviceEUI}
            />
          </FieldContainer>
          {/* <FieldContainer item xs={12} sm={12} md lg>
            <FieldDescription>{t('device-add-key-label')}</FieldDescription>
            <UnifiedInput
              placeholder={t('device-add-key-label')}
              hasBorder
              value={applicationKey}
              name="applicationKey"
              OnChange={handleChange}
              error={!!errors?.applicationKey}
              errorMessage={errors?.applicationKey}
            />
          </FieldContainer> */}
          {/* <FieldContainer item xs={12} sm={12} md lg>
            <FieldDescription>{t('device-add-app-label')}</FieldDescription>
            <UnifiedInput
              placeholder={t('device-add-app-label')}
              hasBorder
              value={deviceApplicationEUI}
              name="deviceApplicationEUI"
              OnChange={handleChange}
              error={!!errors?.deviceApplicationEUI}
              errorMessage={errors?.deviceApplicationEUI}
            />
            {controller && (
              <div
                style={{ display: 'flex', justifyContent: 'center', gap: 8 }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span>{t('device-update-channel-use')} A</span>
                  <Checkbox
                    checked={channelA}
                    sx={{
                      color: 'grey',
                      '&.Mui-checked': {
                        color: '#FF0018',
                      },
                    }}
                    onChange={() => setChannelA((prev: boolean) => !prev)}
                  />
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span>{t('device-update-channel-use')} B</span>
                  <Checkbox
                    checked={channelB}
                    sx={{
                      color: 'grey',
                      '&.Mui-checked': {
                        color: '#FF0018',
                      },
                    }}
                    onChange={() => setChannelB((prev: boolean) => !prev)}
                  />
                </div>
              </div>
            )}
          </FieldContainer> */}
          {sensor && (
            <FieldContainer item xs={12} sm={12} md lg>
              <FieldDescription>{t('device-add-controller')}</FieldDescription>
              <SelectSearch
                multiple
                options={mergedOptions}
                value={devices}
                handleReachEnd={handleScroll}
                loading={loading}
                onOpen={() => setControllerDropdownOpen(true)}
                onClose={() => setControllerDropdownOpen(false)}
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                OnChange={(e, newValue) => setDevices(e)}
                displayOption={(props, option) => {
                  return (
                    <li key={option.value} {...props}>
                      {option.etage} {option.area} {option.subArea} {option.dev}
                    </li>
                  );
                }}
              />

              {devices.length > 1 && (
                <ActionButton
                  buttonLabel={t('device-update-channel-button')}
                  color={'primary'}
                  OnClick={handleOpen}
                  style={{
                    borderRadius: 6,
                    marginTop: '8px',
                  }}
                />
              )}
              {devices.length > 0 && devices.length < 2 && (
                <div
                  style={{ display: 'flex', justifyContent: 'center', gap: 8 }}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span>{t('device-update-channel-use')} A</span>
                    <Checkbox
                      checked={channelA}
                      sx={{
                        color: 'grey',
                        '&.Mui-checked': {
                          color: '#FF0018',
                        },
                      }}
                      onChange={() => setChannelA((prev: boolean) => !prev)}
                    />
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span>{t('device-update-channel-use')} B</span>
                    <Checkbox
                      checked={channelB}
                      sx={{
                        color: 'grey',
                        '&.Mui-checked': {
                          color: '#FF0018',
                        },
                      }}
                      onChange={() => setChannelB((prev: boolean) => !prev)}
                    />
                  </div>
                </div>
              )}
            </FieldContainer>
          )}
        </RowContainer>
      )}

      {!gateway && (
        <RowContainer container>
          <FieldContainer item xs={12} sm={12} md lg>
            <FieldDescription>{t('device-add-model-label')}</FieldDescription>
            <UnifiedInput
              placeholder={t('device-add-model-placeholder')}
              hasBorder
              value={model}
              name="model"
              OnChange={handleChange}
              error={!!errors?.model}
              errorMessage={errors?.model}
            />
          </FieldContainer>
          {/* <FieldContainer item xs={12} sm={12} md lg>
            <FieldDescription>{t('device-add-serial-label')}</FieldDescription>
            <UnifiedInput
              placeholder={t('device-add-serial-label')}
              hasBorder
              value={serialNumber}
              name="serialNumber"
              OnChange={handleChange}
              error={!!errors?.serialNumber}
              errorMessage={errors?.serialNumber}
            />
          </FieldContainer> */}
          {/* <FieldContainer item xs={12} sm={12} md lg>
            <FieldDescription>{t('device-add-serial-label')}</FieldDescription>
            <UnifiedInput
              placeholder={t('device-add-serial-label')}
              hasBorder
              value={assetNumber}
              name="assetNumber"
              OnChange={handleChange}
              error={!!errors?.assetNumber}
              errorMessage={errors?.assetNumber}
            />
          </FieldContainer> */}
        </RowContainer>
      )}
      <RowContainer container>
        {!gateway && (
          <FieldContainer item xs={12} sm={12} md lg>
            <FieldDescription>
              {t('device-add-building-label')}
            </FieldDescription>
            <SelectInput
              values={buildings}
              value={building}
              OnChange={handleChangeBuilding}
            />
          </FieldContainer>
        )}
        <FieldContainer item xs={12} sm={12} md lg>
          <FieldDescription>{t('device-add-floor-label')}</FieldDescription>
          <UnifiedInput
            placeholder={t('device-add-floor-label')}
            hasBorder
            value={floor}
            name="floor"
            OnChange={handleChangeFloor}
            error={!!errors?.floor}
            errorMessage={errors?.floor}
          />
        </FieldContainer>
        <FieldContainer item xs={12} sm={12} md lg>
          <FieldDescription>
            {t('device-add-floor-area-label')}
          </FieldDescription>
          <UnifiedInput
            placeholder={t('device-add-floor-area-label')}
            hasBorder
            value={floorArea}
            name="floorArea"
            OnChange={handleChange}
            error={!!errors?.floorArea}
            errorMessage={errors?.floorArea}
          />
        </FieldContainer>
        <FieldContainer item xs={12} sm={12} md lg>
          <FieldDescription>{t('device-add-floor-sub-label')}</FieldDescription>
          <UnifiedInput
            placeholder={t('device-add-floor-sub-label')}
            hasBorder
            value={floorSubArea}
            name="floorSubArea"
            OnChange={handleChange}
            error={!!errors?.floorSubArea}
            errorMessage={errors?.floorSubArea}
          />
        </FieldContainer>
      </RowContainer>
      {!gateway && (
        <RowContainer>
          {/* <FieldContainer item xs={12} sm={12} md lg>
            <FieldDescription>AWS ID</FieldDescription>
            <UnifiedInput
              placeholder="AWS ID"
              hasBorder
              value={awsId}
              name="awsId"
              OnChange={handleChange}
              error={!!errors?.awsId}
              errorMessage={errors?.awsId}
            />
          </FieldContainer> */}
          <FieldContainer item xs={12} sm={12} md lg>
            <FieldDescription
              style={{ display: 'flex', gap: 5, alignItems: 'center' }}
            >
              AWS ID{' '}
              <div
                style={{
                  display: 'inline-block',
                  width: '10px',
                  height: '10px',
                  backgroundColor: awsId
                    ? ColorType.softGreen
                    : ColorType.primary,
                  borderRadius: '50%',
                }}
              ></div>
            </FieldDescription>

            {/* <UnifiedInput
              placeholder="AWS ID"
              hasBorder
              value={awsId}
              name="awsId"
              OnChange={handleChange}
              error={!!errors?.awsId}
              errorMessage={errors?.awsId}
            /> */}
          </FieldContainer>
        </RowContainer>
      )}
      <div style={{ display: 'flex', gap: 10 }}>
        {(isAdmin || isManager || isBuildingManager) &&
          componentType === 'sensor' && (
            <div
              style={{
                padding: '8px 16px',
                background: '#FF0018',
                borderRadius: 6,
                display: 'flex',
              }}
            >
              <DoDisturbIcon
                style={{
                  height: 19,
                  width: 19,
                  color: '#ffff',
                }}
              />
              <div
                style={{
                  color: 'white',
                  fontSize: 14,
                  fontWeight: '600',
                  lineHeight: '20px',
                  cursor: 'pointer',
                }}
                onClick={handleOpenSilenceModal}
              >
                {sensor?.silenced
                  ? t('button-activate')
                  : t('button-deactivate')}
              </div>
            </div>
          )}
        <div
          style={{
            padding: '8px 16px',
            background: '#FF0018',
            borderRadius: 6,
            display: 'flex',
          }}
        >
          <PencilSquare height={17} width={17} color="#fff" />
          <div
            style={{
              color: 'white',
              fontSize: 14,
              fontWeight: '600',
              lineHeight: '20px',
              cursor: 'pointer',
            }}
            onClick={sendData}
          >
            {t('button-update')}
          </div>
        </div>
        {(isAdmin || isManager || isBuildingManager) && (
          <div
            style={{
              padding: '8px 16px',
              background: '#FF0018',
              borderRadius: 6,
              display: 'flex',
            }}
          >
            <DeleteOutlinedIcon
              style={{
                height: 19,
                width: 19,
                color: '#ffff',
              }}
            />
            <div
              style={{
                color: 'white',
                fontSize: 14,
                fontWeight: '600',
                lineHeight: '20px',
                cursor: 'pointer',
              }}
              onClick={handleOpenDeleteModal}
            >
              {t('button-delete')}
            </div>
          </div>
        )}
      </div>
      <ChannelModal
        open={isSelectChannel}
        handleClose={handleClose}
        devices={devices}
        setChannels={setChannels}
        /* @ts-ignore */
        assignedChannels={sensor?.assigned_controllers}
      />
      <PopupConfirmDelete
        open={confirmDelete}
        handleClick={handleDeleteDevice}
        handleClose={handleCloseDeleteModal}
        message={t('device-delete-title')}
        description={t('device-delete-description')}
        label={t('device-delete-label')}
        pass={activeLocale === 'en' ? 'DELETE' : 'SUPPRIMER'}
      />
      <PopupConfirmSilence
        open={confirmSilence}
        handleClick={handleSilenceDevice}
        handleClose={handleCloseSilenceModal}
        message={t('device-silence-title')}
        description={
          sensor?.silenced
            ? t('device-unsilence-description')
            : t('device-silence-description')
        }
      />
    </Container>
  );
};

const Container = styled('div')`
  padding: 16px 20px;
  border-radius: 10px;
  border: 0.5px ${ColorType.darkGrey} solid;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const TitleContainer = styled('div')`
  color: ${ColorType.darkGrey};
  font-weight: 600;
  letter-spacing: 0.02px;
  font-family: Inter;
`;

const RowContainer = styled(Grid)`
  gap: 12px;
  display: flex;
`;

const FieldContainer = styled(Grid)`
  flex-direction: column;
  gap: 6;
  display: flex;
`;

const FieldDescription = styled('div')`
  color: ${ColorType.darkGrey};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  word-wrap: break-word;
  font-family: Inter;
`;

export default DeviceUpdateCard;
